import { ApiResponse, apiUpload, authHeader } from './api';

type AttachmentSize = {
  type: string;
  value: string;
  width: number;
  height: number;
};
export type Attachment = {
  _id: string;
  value: string;
  width: number;
  height: number;
  size: AttachmentSize;
};

type Role = 'customer' | 'shipper' | 'merchant' | 'admin';

type Data = {
  url: string;
};
export const uploadAvatar = (role: Role, formData: FormData) => {
  return apiUpload.post<ApiResponse<Data>>(`/upload/${role}/avatar`, formData, {
    headers: authHeader(),
  });
};

export type Photo = {
  thumbnail: string;
  image: string;
};
export const uploadPhoto = (role: Role, formData: FormData) => {
  return apiUpload.post<ApiResponse<Photo>>(`/upload/${role}/photo`, formData, {
    headers: authHeader(),
  });
};

export const uploadPhotos = (role: Role, formData: FormData) => {
  return apiUpload.post<ApiResponse<Photo[]>>(
    `/upload/${role}/photos`,
    formData,
    {
      headers: authHeader(),
    },
  );
};

export const uploadImage = (role: Role, formData: FormData) => {
  return apiUpload.post<ApiResponse<Data>>(`/upload/${role}/image`, formData, {
    headers: authHeader(),
  });
};

export const uploadFile = (role: Role, formData: FormData) => {
  return apiUpload.post<ApiResponse<Data>>(`/upload/${role}/file`, formData, {
    headers: authHeader(),
  });
};
